import { render, staticRenderFns } from "./LoginFromPc.vue?vue&type=template&id=215235b8&scoped=true"
import script from "./LoginFromPc.vue?vue&type=script&lang=js"
export * from "./LoginFromPc.vue?vue&type=script&lang=js"
import style0 from "./LoginFromPc.vue?vue&type=style&index=0&id=215235b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215235b8",
  null
  
)

export default component.exports